import React, { ReactChild, ReactChildren } from 'react';

import { Spin as ASpin, SpinProps } from 'antd';

export interface ISpinParams extends SpinProps {
  children: ReactChild | ReactChild[] | ReactChildren | ReactChildren[];
}

export const Spin = ({ children, ...rest }: ISpinParams) => (
  <ASpin style={{ top: '200px' }} {...rest}>
    {children}
  </ASpin>
);
